import type { Privilege } from "../types";
export type AccessLevel = "none" | "read" | "write";
export const accessLevel = (privilege?: Privilege): AccessLevel =>
  privilege?.write ? "write" : privilege?.view ? "read" : "none";
export const privilegeForAccess = (level: AccessLevel): Privilege => ({
  view: level !== "none",
  write: level === "write",
});
